import { render } from "./SecondaryButton.vue?vue&type=template&id=6d8e65f9&scoped=true"
import script from "./SecondaryButton.vue?vue&type=script&lang=js"
export * from "./SecondaryButton.vue?vue&type=script&lang=js"

import "./SecondaryButton.vue?vue&type=style&index=0&id=6d8e65f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8e65f9"]])

export default __exports__